import { useEffect, useState } from 'react';

import { Button } from '~/components/ui/button';
import { Modal } from '~/components/ui/modal';
import { useToast } from '~/components/ui/use-toast';

interface Props {
  email: string;
  onClose: () => void;
}

export default function ReportAProblemModal({ onClose, email }: Props) {
  const toast = useToast();

  // HACK: https://github.com/radix-ui/primitives/issues/1386
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(true), []);

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    toast.toast({ title: 'Success!', description: 'Email copied to clipboard' });
    onClose();
  };

  return (
    <Modal title="Report a problem" open={open} onClose={onClose}>
      <div className="flex flex-col gap-2 text-body2">
        <p>To report a problem such as inaccurate or malicious content, please email us with:</p>

        <ul className="ml-6 list-disc">
          <li>Your Fighters Passport account email</li>
          <li>Profile or gym name</li>
          <li>Page URL</li>
          <li>Detailed description of the issue</li>
        </ul>

        <p>Expect a response within 1-3 business days.</p>
      </div>

      <div className="mt-6 flex justify-end gap-2">
        <Button variant="ghost-secondary" onClick={onClose}>
          Close
        </Button>

        <Button onClick={handleCopy}>Copy Email Address</Button>
      </div>
    </Modal>
  );
}
